module.exports = __webpack_public_path__ + "static/home-4640020abc0dbe6a7e1db46ea0c65408.jpg";